import {
  forwardRef,
  PopoverHeader as ChakraPopoverHeader,
  PopoverCloseButton,
} from '@chakra-ui/react';
import type { PopoverHeaderProps as ChakraPopoverHeaderProps } from '@chakra-ui/react';

import { usePopoverContext } from './utils/PopoverContext';

export interface PopoverHeaderProps extends ChakraPopoverHeaderProps {
  hasCloseButton?: boolean;
}

export const PopoverHeader = forwardRef<PopoverHeaderProps, 'header'>(
  ({ children, hasCloseButton = true, ...restProps }, ref) => {
    const { size } = usePopoverContext();

    return (
      <ChakraPopoverHeader ref={ref} {...restProps}>
        {children}
        {hasCloseButton && (
          <PopoverCloseButton
            size={size}
            mr={-0.75}
            color="feature.secondary"
            position="static"
          />
        )}
      </ChakraPopoverHeader>
    );
  },
);
PopoverHeader.displayName = 'PopoverHeader';
